import {createNotesFromApiResponse} from "../factories/soundsliceFactory";
import {
  ssGetNotes,
  ssNotationLoaded,
  ssAudioEnd,
  ssBarCount,
  ssCurrentBar,
  ssDuration,
  ssMouseUp,
  ssNoteClick,
  ssSeek,
  ssPlay,
  ssLoopChanged,
  ssPause,
  ssCurrentTime,
  ssAudioLoaded,
  ssSpeed,
  ssAudioSourceChanged,
  ssPlayerReady,
  ssOneTimeLoopEnd,
  ssZoom
} from "./eventBus/soundslice/receiveMessageFromSoundsliceIframeEventBus";
import {logger} from "./log/logger";

/**
 * Responsible for:
 * - listening to window messages (from soundslice).
 * - converting data from soundslice to appropriate types e.g. Note
 * - triggering rxjs events that correspond to the data received from soundslice.
 */

export const soundsliceRequestMethods = {
  clearLoop: "clearLoop",
  seek: "seek",
  clearTempNotes: "clearTempNotes",
  setSpeed: "setSpeed",
  pause: "pause",
  editNote: "editNote",
  play: "play",
  getNotes: "getNotes",
  getDuration: "getDuration",
  getBarCount: "getBarCount",
  sendNoteClicks: "sendNoteClicks",
  drawTempNote: "drawTempNote",
  setTrackVisibility: "setTrackVisibility",
  getCurrentBar: "getCurrentBar",
  getCurrentTime: "getCurrentTime",
};

export const soundsliceResponseMethods = {
  ssPlayerReady: "ssPlayerReady",
  ssGetNotes: "ssGetNotes",
  ssPlay: "ssPlay",
  ssAudioEnd: "ssAudioEnd",
  ssBarCount: "ssBarCount",
  ssDuration: "ssDuration",
  ssNoteClick: "ssNoteClick",
  ssMouseup: "ssMouseup",
  ssSeek: "ssSeek",
  ssCurrentBar: "ssCurrentBar",
  ssNotationLoaded: "ssNotationLoaded", //needs to happen before getNotes can be called/sent.
  ssAudioLoaded: "ssAudioLoaded", //maybe needs to happen before play will immediately respond?
  ssLoopChange: "ssLoopChange",
  ssPause: "ssPause",
  ssCurrentTime: "ssCurrentTime",
  ssSpeed: "ssSpeed",
  ssAudioSourceChanged: "ssAudioSourceChanged",
  ssOneTimeLoopEnd: "ssOneTimeLoopEnd",
  ssZoom: "ssZoom",
};


export function registerWindowMessageListener(){
  unregisterWindowMessageListener();
  window.addEventListener('message', handleMessageFromSoundSlice);
  return unregisterWindowMessageListener;
}

export function unregisterWindowMessageListener(){
  window.removeEventListener('message', handleMessageFromSoundSlice);
}

function handleMessageFromSoundSlice(event: MessageEvent){
  if(!event.data || event.origin !== "https://www.soundslice.com"){ return; }
  logger.vendorSoundSliceMessage.debug({message: `message from soundslice [${Date.now()}]: ` + event.data});
  const command = JSON.parse(event.data) || {};
  const {method, arg, state} = command;

  switch(method){
    case soundsliceResponseMethods.ssNotationLoaded:
      ssNotationLoaded(state);
      break;
    case soundsliceResponseMethods.ssGetNotes:
      const notes = createNotesFromApiResponse(arg);
      ssGetNotes(notes, state);
      break;
    case soundsliceResponseMethods.ssBarCount:
      ssBarCount(arg, state);
      break;
    case soundsliceResponseMethods.ssDuration:
      ssDuration(arg, state);
      break;
    case soundsliceResponseMethods.ssAudioEnd:
      ssAudioEnd(state);
      break;
    case soundsliceResponseMethods.ssPlay:
      ssPlay(state);
      break;
    case soundsliceResponseMethods.ssSeek:
      ssSeek(arg, state);
      break;
    case soundsliceResponseMethods.ssCurrentBar:
      ssCurrentBar(arg, state);
      break;
    case soundsliceResponseMethods.ssNoteClick:
      ssNoteClick(arg.pitch, state);
      break;
    case soundsliceResponseMethods.ssMouseup:
      ssMouseUp(state);
      break;
    case soundsliceResponseMethods.ssLoopChange:
      ssLoopChanged(arg[0], arg[1], state);
      break;
    case soundsliceResponseMethods.ssPause:
      ssPause(state);
      break;
    case soundsliceResponseMethods.ssCurrentTime:
      ssCurrentTime(arg, state);
      break;
    case soundsliceResponseMethods.ssAudioLoaded:
      ssAudioLoaded(arg, state);
      break;
    case soundsliceResponseMethods.ssSpeed:
      ssSpeed(arg, state);
      break;
    case soundsliceResponseMethods.ssAudioSourceChanged:
      ssAudioSourceChanged(arg, state);
      break;
    case soundsliceResponseMethods.ssPlayerReady:
      ssPlayerReady(state);
      break;
    case soundsliceResponseMethods.ssOneTimeLoopEnd:
      ssOneTimeLoopEnd(state);
      break;
    case soundsliceResponseMethods.ssZoom:
      ssZoom(arg, state);
      break;
    default:
  }
}

//todo: move to lesson page
registerWindowMessageListener();